import { StyleSheet } from "aphrodite";

export const style = StyleSheet.create({
  numbers: {
    fontSize: "35px",
    lineHeight: "35px",
    flex: "1",
  },
  name: {
    flex: "1",
    fontSize: "14px",
    textAlign: "right",
    textTransform: "uppercase",
  },
  defaultWhite: {
    backgroundColor: "#fff",
    /*padding: "25px 20px",*/
    padding: "8px 20px",
    flex: "1",
    margin: "10px",
    boxShadow: "2px 0px 12px #ccc",
    display: "block",
    verticalAlign: "center",
    alignItens: "center",
    color: "#4969D6 ",
    cursor: "pointer",
    borderRadius: "10px",
    position: "relative",
  },
  defaultBlue: {
    /*backgroundColor: "#4969D6",*/
    /*padding: "25px 20px",*/
    border: "2px solid #4969D6",
    padding: "8px 20px",
    flex: "1",
    margin: "10px",
    boxShadow: "2px 0px 12px #ccc",
    display: "block",
    verticalAlign: "center",
    alignItens: "center",
    /*color: "#fff",*/
    cursor: "pointer",
    borderRadius: "10px",
    position: "relative",
  },

  /* ============== */

  box: {
    backgroundColor: "#fff",
    height: "160px",
    padding: "15px",
    boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.1)",
  },
  boxLeft: {
   // width: "50%",
    float: "left",
  },
  title: {
    textTransform: "uppercase",
    fontSize: "16px",
    /*lineHeight: "18px",*/
  },
  boxRight: {
   // width: "50%",
    float: "right",
    //textAlign: "right"
  },
  sub: {
    textTransform: "uppercase",
  },
  subRed: {
    color: "#E03131",
    textTransform: "uppercase",
  },
  subNormal: {
    fontSize: "13px",
    /*lineHeight: "14px",*/
    fontWeight: "bold",
  },
  linkHover: {
    ":hover": {
      textDecoration: "underline",
    },
  },
  selectedLink: {
    textDecoration: "underline",
    fontWeight: "bold",
    fontSize: "14px",
  },
  boxNumber: {
    fontSize: "55px",
    lineHeight: "55px",
  },
  activeRed: {
    textTransform: "uppercase",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#E03131",
  },
  active: {
    textTransform: "uppercase",
    fontSize: "12px",
    lineHeight: "14px",
  },
  inactive: {
    textTransform: "uppercase",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#818181",
  },
  grid: {
    padding: "",
    margin: "0",
  },
  row: {
    paddingBottom: "15px",
  },
  col: {
    padding: "5px",
  },
  cardLabel: {
    /*fontWeight: "normal",*/
  },
});
